/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { GetGenitoreStudenteViewImpl } from './getGenitoreStudenteViewImpl';
import { GetPortafogliViewImpl } from './getPortafogliViewImpl';
import { GetScuolaDTO } from './getScuolaDTO';

export interface GetStudenteDTO { 
    id?: string;
    nome?: string;
    cognome?: string;
    codiceFiscale?: string;
    dataNascita?: string;
    cittaNascita?: string;
    provinciaNascita?: string;
    nonAutosufficiente?: boolean;
    cittadinanza?: string;
    ordinamentoScolastico?: GetStudenteDTO.OrdinamentoScolasticoEnum;
    classe?: string;
    sezione?: string;
    dietaAlternativa?: string;
    religione?: string;
    identificativoMenuExtra?: string;
    note?: string;
    isEsente?: boolean;
    isSospeso?: boolean;
    motivoEsenzione?: string;
    scuola?: GetScuolaDTO;
    genitore?: GetGenitoreStudenteViewImpl;
    portafogli?: GetPortafogliViewImpl;
}
export namespace GetStudenteDTO {
    export type OrdinamentoScolasticoEnum = 'SCUOLA_INFANZIA' | 'PRIMARIA';
    export const OrdinamentoScolasticoEnum = {
        SCUOLAINFANZIA: 'SCUOLA_INFANZIA' as OrdinamentoScolasticoEnum,
        PRIMARIA: 'PRIMARIA' as OrdinamentoScolasticoEnum
    };
}